export function isEmail(email: string): boolean {
    const regex = /\S+@\S+\.\S+/;
    return regex.test(email);
}

export function makeId(): string {
    const randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    return randLetter + Date.now();
}

Object.defineProperty(String.prototype, 'capitalize', {
    value: function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    },
    enumerable: false,
});

export function hex2hsl(H: string, saturation: number | null = null, lightness: number | null = null): string {
    // Convert hex to RGB first
    let r = 0;
    let g = 0;
    let b = 0;
    if (H.length == 4) {
        r = '0x' + H[1] + H[1];
        g = '0x' + H[2] + H[2];
        b = '0x' + H[3] + H[3];
    } else if (H.length == 7) {
        r = '0x' + H[1] + H[2];
        g = '0x' + H[3] + H[4];
        b = '0x' + H[5] + H[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    const cmin = Math.min(r, g, b);
    const cmax = Math.max(r, g, b);
    const delta = cmax - cmin;
    let h = 0;
    let s = 0;
    let l = 0;

    if (delta == 0) h = 0;
    else if (cmax == r) h = ((g - b) / delta) % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;

    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    if (saturation) {
        s = saturation;
    }

    if (lightness) {
        l = lightness;
    }

    return 'hsl(' + h + ',' + s + '%,' + l + '%)';
}

export function hex2pastel(H: string, lightness: number = 93): string {
    return hex2hsl(H, null, lightness);
}

export function pascalize(str: string, separator: string = '_'): string {
    return str
        .toLowerCase()
        .split(separator)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
}

export function camelize(str: string, separator: string = '_'): string {
    return str
        .toLowerCase()
        .split(separator)
        .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
        .join('');
}

export function snakeize(str: string, separator: string = '-'): string {
    return str.toLowerCase().split(separator).join('_');
}
